import { Injectable, signal } from '@angular/core';
import { Profile } from '../../models';

@Injectable({ providedIn: 'root' })
export class ProfileService {
  private readonly _profile = signal<Profile | null>(null);

  readonly profile = this._profile.asReadonly();

  set(profile: Profile): void {
    this._profile.set(profile);
  }

  clear(): void {
    this._profile.set(null);
  }
}
